import React from 'react';
import styled from 'styled-components';
import CO2 from '../../components/CO2/CO2';
import Up from '../../assets/up.png';
import ReusableDetailCard from '../../components/ReusableDetailCard/ReusableDetailCard';


const Container = styled.div`
  display: flex;
  flex-direction:column;
  width: 100%;
  border: none;
  border-radius: 9px;
  justify-content: space-around;
  background-color: rgba(0,0,0,0.5);
  backdrop-filter: blur(3px);  
  overflow:hidden;
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
  

`;

const Viz = styled.div`
  display: flex;
  width:100%;
  height:300px;
  justify-content: flex-start;
  align-self:stretch;
  overflow:hidden;
  border-radius: 9px;
  border:none;
  background-color: rgba(0,0,0,0.5);
  position: relative;

    @media (max-width: 768px) {
    height: 60vh;

  }
`;



class CardCO2 extends React.Component {
  render () {
   return (

<Container>
    
    <Viz>
      <CO2 />

    </Viz>

   <ReusableDetailCard
   trend= {Up}
   metricsm="413ppm"
   diagnosis="Since the industrial revolution, the atmospheric concentration of carbon dioxide has increased from 280 to over 400 parts per million due to the burning of fossil fuels such as coal, gas, and oil, along with land use change."
   prediction="A higher concentration of CO2, a heat trapping gas, is causing warmer temeratures on land and at sea. This shift makes society, ecosystems and crops  vulnerable to pests, disease, extreme storms, and more (NASA)."
   significanceorthreat="THREAT"
   confidence="CONFICENCE LV: 95%"
   />
</Container>

  );
 }
}

export default CardCO2;
